<template>
  <div class="wrap">
    <div class="header">
      <img src="../assets/images/logo.png" alt="">
      <img src="../assets/images/title.png" alt="">
    </div>
    <div class="menu" v-show="!showVideo">
      <nav>
        <div class="el-menu-item" v-bind:class="{ active: isZfkj }" @click="menu('zfkj')">政府会计</div>
        <div class="el-menu-item" v-bind:class="{ active: isQykj}" @click="menu('qykj')">企业会计</div>
        <div class="el-menu-item" v-bind:class="{ active: isNbkz }" @click="menu('nbkz')">内部控制</div>
        <div class="el-menu-item" v-bind:class="{ active: isNmzyhzs }" @click="menu('nmzyhzs')">农民专业合作社会计制度</div>
        <div class="el-menu-item" v-bind:class="{ active: isZyddgf }" @click="menu('zyddgf')">会计人员职业道德规范</div>
        <div class="el-menu-item" v-bind:class="{ active: isDxwlfz }" @click="menu('dxwlfz')">电信网络反诈宣传</div>
        <div class="el-menu-item" v-bind:class="{ active: isQt }" @click="menu('qt')">其他</div>
      </nav>
    </div>
    <div class="content" v-bind:class="{ foot: showVideo }">
      <div class="video-wrap" v-show="!showVideo" ref="videowrap">
        <div class="video" v-for="(item, index) in videoList" :key="index" @click="playVedio(item)">
          <img :src="item.cover" alt="" class="img" style="">
          <p class="video-title" :title="item.title">{{item.title}}</p>
          <p class="video-text" :title="item.publish_time">发布时间：{{item.publish_time}}</p>
          <hr style="color: #D7D7D7;border-bottom:none;border-top:1px solid #D7D7D7;">
          <p class="video-content" :title="item.content">{{item.content}}</p>
        </div>
        <div class="video-white" v-for="(item, index) in whiteDiv" :key="index+'2'">
        </div>
      </div>
      <div class="player"  v-show="showVideo"  style="">
        <p style="width:100%;text-align:left;font-size:18px;">{{video.title}}</p>
        <p style="width:100%;text-align:left;font-size:14px;">{{video.content}}</p>
        <div id="mse"></div>
      </div>
    </div>
    <div class="footer">
      ————    &nbsp;&nbsp;&nbsp;&nbsp;江苏省财政厅版权所有&nbsp;&nbsp;&nbsp;&nbsp;    ————
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer'

export default {
  name: 'login',
  data () {
    return {
      player: null,
      videoList: [],
      showVideo: false,
      video: {},
      whiteDiv: [],
      type: 'zfkj',
      isZfkj: true,
      isQykj: false,
      isNbkz: false,
      isDxwlfz: false,
      isNmzyhzs: false,
      isZyddgf: false,
      isQt: false,
      videoListurl: window.zvconfig.url.videoListurl,
      videoDetailurl: window.zvconfig.url.videoDetailurl,
      watchurl: window.zvconfig.url.watch
    }
  },
  methods: {
    // 设置视频配置(注意：initPlayer应放在异步函数里或mounted之后，不可在created里直接加载，否则不生效)
    initPlayer (url) {
      this.player = new Player({
        // el、url为必选配置，其它为可选配置
        id: 'mse',
        url: url,
        autoplay: false,
        width: 900,
        height: 500,
        playbackRate: [0.5, 0.75, 1, 1.5, 2],
        defaultPlaybackRate: 1
        // 封面图
        // poster: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAEE5JREFUaIHFmnl0VdW5wH/7TPfmThmEhICKIkEwuZZJQFsKMsgk+FSCmMVqu+xb9tVqh9f36hM6qG/5WodWW2q7nlb7uooigiJWRGWQSLGADNGbKBoqMiQ2TEnumHPPsN8fd0jCnIS23x9ZuXvvc87+nfPt/X37+z5RWFTE30EEgOu6ZxygKEruX3mhH65dwHsJ27YxTVPati1VVcXv9yOE8AAqoAAu4EgpzXg8juM4aJqGx+MRmqbBBQLsK5RwXVckUykXKeXAgQMD4aqqK8eNHz9y6NCh4avD4ct0wyhThAgCOmBJKWPpdLrlg0jks3379kV2bN9eF6mv/7i5uTmOEPgKChRFUSR9ABS9VD/hOI5IJBJuYWGhev3kydfMr66+5frJk28oLy+/KgtwvmJ9/vnnH27evPmtlatWvfz222+/197e7vj9fkVV1V7B9RRKACIej7vBYFBZuHDh7Lu++c27wuHwDWRUrK/iRCKRt37z29/+5oUVK16PRaOuPxBQRAbsvOF6AqVYliU7OjrknNmzxzzw4IP3jxo58saTB0VNh/ojafY0m3xywqI5ZtPW4WK5El0RFHkVBgZVhl1kMKrcQ1WpQchz6vvYU1f32k9+/OP7177++i6v1yt0XRdk1uSFgRJCKIlEwg2FQvr/PPTQ9++8884lQKDrmI2fJnixIc47B0wORl06HJBCQVMEQggE2dctJbYrEdLFq8KlIYUvD/awoDLA1CH+kx8df+qppx5avGTJz6PRqOX3+xUp5TnBzgklhFDa29vdcDhc9uyzz/7vmNGjb+ra//KHMZbuaGdbk0Vaqnh1FV1TEEKQ3dnPIBIpJZbt0mE5GMJhwiCde8YVcstVwW4jd+/e/eodd9xx5weRSEthYeE5wc4KJYRQotGoO3bs2KEvrVr14sUXXzwq1/fhUZP7Nhzn9X0mQtXweTSEULIcZ4M5FQ4JUrokTRvp2Mwe6uGn0y7iqv6e/KjDhw/vuXX+/AU7d+7cFwqFzgp2Rqgc0DXXXFOxZs2aV8tKS4fn+v6wp517N7Zy1FQIenWEUJAIRE9YTssnkdIl1mHR3+Py8NRivjqqMN/dcuTI3ptuumnee++913g2MNXr9Z6WKZlMysrKyrJX16x5tby8vCrXsWTjMe7d2IajGPg8BkJRUBSB5ULayWwGvRYhEELBo6mkbMHqj2KYtsPUIT4AAn5/v1mzZn15/YYNq5ubm+PZzeO8oIRt28Ln8+kvv/TSsmHDhn051/Gd14/w2LY4AZ8XTdNACGwXyoMKS6eH2N/m8Nc2B00R9IUNIVAVBU1T2fDXJK1Ji1kVmU0kFAoNmDB+/JUrVqx4ybIs2cXdOiuUkkgk3CeeeOIHc+bMuSvX+KONx3h0W5xCvxdFUcnpmiMhoAt+OyNEzVVefLpgd4tNmykxVNGj1XUymBACj67yzmcpHMdhSvaLlZeXX1lSUpJ65ZVXtng8HoWTbNjJUCIej8s5c+aMeezRR39P1jP44/vt/MeGdoI+D4raCQTgSggagq9dXUDAEEy8xODGKzy0JFwiR21cCVpvP5sQCEVgaAqb9ie5vEjhCwMy8x0zevS1u3bterOhoaHZMIxuD+gG5TiOUlBQoD63bNnvSktLRwB8fMyk5uWjOIqRV7mukoP6xigfHjXT19+nUD3Cy4iLNCJHbQ5FXfReq2TWzgnB5v0J5g0roJ9PA9DD4fClzz3//ArHccj6i0DGc85fnUgk3JqamplVVVUzAaSEe9cf56ipYOjqKUDnkvnDvWxZVMJ91/nRFIinZe+8VCEwdJVjpsK9648jszepqqqaefvtt89MJBIuXexIHsp1XVFUVKTdfffd38m1/enjOGv3mQS9OohTF+TpJJaWrN+fzv8u8io8NCnAhppiZgwxSKQlptMLNJExH2v3mfzp43i++Z577vlOUVGR5rruqVDJVMqdMmXK2BHDh08GcFzJ49vaEGrWqJ6n2C58bW071avb+PiEnW8fXabzWnUxz8wOcXFQpd2UuD1kE0JBqBqPb2vDyV48Yvjw66dMmTI2mUrlbVZutop0XRZUV1eTPWNtOZDiL00WPs+p6+hsogrwaoJVH3Uw+blWHtmWIGV3zv4r4QK2LCrh22MLkBIS6R6QCYHPo/GXJostB1L5Ry6orq6WmVO2kv9j27YcNGhQYNKkSTNyI1+oj2FJpUdfKf9swO9RiKcl/7U5zpTnW3nz006VLPMrPDEtxLrbivnSJTpRU5J2zpdLwZIKK+pj+bZJkybNGDRoUMC2M29PAUin0zIcDg8vKysbBhAzXWoPmHh1rWdu3EmiKVDoEez8m8XcVa18e32Ufa2ds//ixTrrby/h1zcE6e8T56eSAry6xuYDJjEzo3FlZWXDwuHw8HQ6nYcSlmUxYfz4kWTtUqTF5EDUQdcU+kRFxjjbluSXU4N8a7SPr65p42fvJshppCrgm6N9vLOohK9/oQDLlSSts5EJdE3hQNQhcsTMNeoTxo8faVkW5LY0VVUZWlGR9+/q/mbS4Yjs8aGXIqDDlpimy+/nFFJRpPLrvyR4anYhz72fYtwzx6g91KmSl4ZUnp4VYs2txYwZoNNuSqwz+OFCCDocQd3neSgqKirCqqoiAcV1Xfx+v6iqrLw8N+CT4+ksb++gJJBIugz2K6y9rRhdhXkr2/h1XYpH3o2ztqaYyZcYzHv+BHeui9KS6Jz99MsNNtUU8/D1AUKGIJqWebvU7Y0JJTPPrFRWVl7m9/uFdN3MmhJC6IZhlOUGNMWcXrs2rsyo1AOTArx2WzGfHLV5dW8H4QEauqHxx306d65NMnuYl2139KM55jDu98f5vw/yuxleTfCf4/3ULiph4QgvKVvSYXcn0xRBU6xzfRqGUSqE0KFzS9dEJowFQFuH2yfVUwSkJdy4vJUPjjncMcbHpEu9jFBbePby1XzjimZmLmvnwXdNEpakOeHyr+uizFzRSu3BdN7rqChWeW5eIatvLWLsAB27izoKIWjrcLv+DpE1R3k7RZcYoOXIrOL1HEwRYLnw0OYY/3KVl5qwl6Au+MaYAi7xWwxp28DUT7/PjtJFfNa4g83NGoGsP7rpQDoDdZK6zRziYdxAHSffkfH+0909Ey3HkwNxgbz511WBzEeleg4mAG+BQuSIzfZDFhMH6wwvcSgsHcqy4LOYl8X54er3OW4MwLDTxNKSGUMMHpwYYMyA7iHDNY0mD2yJU3/Uxp93xjOzM9Ruc7OzHHkoW0qZt2ZFXgUpbfoimiLYeCiNmXSpudrLly4z+OBokoOxKK7iZ4cVBteioliy+LoQXwsXdLu+8YTD/X+O89LHHQBdgLJYUlLkVbv+jmbBMlBSSiudTrfkBgwKqtiu1ScoSWbDqCrX+fpIH8/uSfLwljhfGesjbTuodPCtsX4WX+unzN/ptXTYkqW7kvxiR5IjSZegcfqDpu1KBgU7odLp9BEppQWgKYpCPB6XDQ0N+8PhMADDLjJAJumt+uVEiIwq/3x7gge2xMEQRFMulxaqvHF7CdOGGN3Gr9+f5idb4mxrtvDpgpBxpmdLkG5mnllpaGj4LJFISH8gIDQAx3FobGyszw0YOcCDV83E5fpifw1FsK/d4b7aOI6UXFKocuMwL184ad0cjDr899YEz9WncGTGtTqbSCnxqpKR5Z0htMbGxojjOAgy6id1XWfb9u11gAXo4TIPg0MqBxMuhtE3I2zaEkOFmkofP7rOz+DCTpVxXHiqLsnD2xIcjGZU7Rw8QCYAOjikEi7NQ1nbtm+v03UdQCoAhmGISCSyt6Wl5ROAoEdh0mAPHZbT64SK7UraTcnoATqv3FrM72aFugFtPZxm+gsnuPutGEdTkkLPeR73JXRYDpMGewh6MmuxpaXlk0gksjcXq8js65ommpqa4rW1tW/mrl1YFUQXDucRuj5FYmlJQBf8bHKATTXF3HB5p+63JFy+uyHKrBWt/PmwRcgjMHpwupHSRRcOC6s6Q9O1tbVvNjU1xTVN64QCXKEovLhy5Uqy2+LEwQVcO0gnadqcxvk6o9huJjbxzqISfjDBT4HW+fr/EEkxcdkJfrUzhRAC/+ljkWcjImnaXDtIZ+LgvAlwXly5cqXIxP86T4oAvoICZdOmTTs/2rt3M4CqCL43oQjp2D36WkVewZM3BLmqX2eScvffLG5c2crXX49yOOacv6qdwuQiHZvvTShCzd7go7173960adNOX0FBnqXzH0WRbW1t9tKlS3+Va5t7ZYA5Qz3EUhbiPMG6Tratw2VJbYxpyzMn36Ah8mG0nhNlYuxzhnqYe2VnFmnp0qW/amtrs88UIpN+v19Zvnz5uvr6+jcgY2cemX6R29/rWqbl9EgNV+3tYOKyE/z03SS2S96/6x2QJG059PO4PDz9oryZqW9oeGP58uXr/H5/tyhttyWqqqqMxWL24iVLfgikAIb184ilM4tbrbQZc12HM22HWvZOHx6zWbC6nZpX29nX6lDoFag9D3N0JcJ1Hcx0msemF3Nlv/w2nlp83+IfxWIxO5sb7uQ4OZZuGIYSqa9vHjhwoBwzevRUQFSWej0q9tF1+1I+j6aqQoh8hMmVUOwVLKosYOmuJP+2Lsrulozz2acMCGRSO65LNGGy5ItBvnttSb7rd888c/8vHv/FikAgoAghukGdLj8lbNsWHo9H27Bhw6pRI0fOzbY7//7GEevx7QlvyO/JJwlyYecBAYW6FpsCTeS/Wl+BXNchmjT59lg/v5xdmu/aU1f3p2nTps03TdPWNO2UJPdp81OKopBIJJytW7dumjd37vRQKDQAUGYM9WuW4/D2/gRCKKhKJg1qOhn749P7mMLpApS2bFKmyX1fDPHojP75rqampverFyxY0NTUFPV4PJwMdEYoyKjhoUOH4n/eunXj3Hnzpgf8/n4AU4f4uDSksOWzBK0dLoYqUITofWbjJJhMJjFNke6wdGYJ37+uU+VajhzZe/Mtt9xSV1d3MBgMnpLCOScUIL1er7J///7jtbW1b86aOXNiKBQqBxhZ7mV2RQGHWk0+bDEz5QSqyJxH+5TztUin08y5wuCPN5cyfWhntv7w4cN7br755lvOJ+d7Nqg82Keffnp848aNr1wzblzFwPLy4QD9/Rq3h4NU9ddojpp81pomZbkIMrbqVKxc0UEnjJQuluWQMC2kY3HtIJXHppfw4JR+9Pd3Gu9du3evWXjbbQv37NlzqM/Z+fygc9VRSNi4P1NHUZutozDPo47Ck62jmJSto5hyue/kgE/8qaeffmjx4sUXto6i61jLsjhXxUt7h0PDkTS7P++g8YSdr3hJuxIjX/GiMaxEZ1S5h8pSg0LvP6Hipet4CSLRtTbprru+Fa6qms6Fqk2qr1//myeffPKFF1/8h9QmdbsuV0VWVFSkTp48eVz1/Pk3T+57FdnqzZs372hra/uHVpGdcr3ruiKZTLoAuXq/8ePHj6yoqLi6KhwebOh6WZdAoy2ljKYtq6U+EjnQ2Nj4wfYdO+oikUim3g/w+Xz/tHq/096rS2Um56rMTCQSf7fKzAsJ1e2+8M+rof1/DX1XtdhJG/UAAAAASUVORK5CYII=`
      })
    },
    menu (type) {
      this.isZfkj = false
      this.isQykj = false
      this.isNbkz = false
      this.isZyddgf = false
      this.isDxwlfz = false
      this.isNmzyhzs = false
      this.isQt = false
      this.type = type
      if (type === 'zfkj') {
        this.isZfkj = true
      } else if (type === 'qykj') {
        this.isQykj = true
      } else if (type === 'nbkz') {
        this.isNbkz = true
      } else if (type === 'zyddgf') {
        this.isZyddgf = true
      } else if (type === 'dxwlfz') {
        this.isDxwlfz = true
      } else if (type === 'nmzyhzs') {
        this.isNmzyhzs = true
      } else if (type === 'qt') {
        this.isQt = true
      }
      this.getList()
    },
    getList () {
      const type = this.type
      this.$axios.post(this.videoListurl, {
        type: type
      }).then(res => {
        if (res.data.result === '00000') {
          this.videoList = res.data.data.video_list
        } else {
          this.$Message.error(res.data.infomation)
        }
      })
    },
    getData (uuid) {
      this.initPlayer(this.watchurl + '?uuid=' + uuid)
    },
    playVedio (data) {
      window.open(`${window.location.href}?videoId=${data.uuid}`, '_blank')
    },
    calc () {
      this.whiteDiv = []
      // eslint-disable-next-line no-unused-expressions
      const width = document.getElementsByClassName('video-wrap')[0].offsetWidth
      // 一行几个
      const num = Math.floor(width / 280)
      // 计算空缺
      const _length = num - this.videoList.length % num
      for (var i = 0; i < _length; i++) {
        this.whiteDiv.push('div')
      }
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    this.calc()
    const _this = this
    window.onresize = function () {
      _this.calc()
    }
    if (window.location.href.indexOf('videoId') > -1) {
      const uuid = window.location.href.split('videoId=')[1]
      this.$axios.post(this.videoDetailurl, {
        uuid: uuid
      }).then(res => {
        console.log(res)
        if (res.data.result === '00000') {
          this.video = {
            title: res.data.data.title,
            content: res.data.data.content,
            publish_time: res.data.data.publish_time
          }
        } else {
          this.$Message.error(res.data.infomation)
        }
      })

      this.showVideo = true
      // 请求视频路径
      this.getData(uuid)
    } else {
      this.showVideo = false
    }
  }
}
</script>

<style lang="less" scoped>
.wrap{
  height: 100%;
  width: 100%;
  .header{
    height: 70px;
    width: 100%;
    background: #E6E6E6;
    padding: 10px 100px;
  }
  .menu{
    width:100%;
    height: 80px;
    nav{
      display: flex;
      align-items: center;
      justify-content: center;
      }
      nav .el-menu-item{
        color:#000000;
        padding: 15px 30px;
        position: relative;
        text-align: center;
        border-bottom: transparent;
        display: flex;
        transform: 0.4s;
        font-size: larger;
        font-weight: bold;
      }
      nav .el-menu-item:hover{
        background-color: darkgray ;
        border-bottom: solid 6px;
        border-bottom-color: brown;
        height: 80px;
      }
      .active{
        background-color: darkgray ;
        border-bottom: solid 6px;
        border-bottom-color: brown;
        height: 80px;
      }
  }
  .foot{
    height: calc(100% - 140px) !important;
  }
  .content{
    width: 100%;
    height: calc(100% - 220px);
    padding: 20px 50px 100px 50px;
    // text-align: center;
    overflow: auto;
    position: relative;
    .player{
      position: absolute;
      left: 50%;
      margin-left: -450px;
    }
    .back{
      display: inline-block;
      width: 100%;
      text-align: left;
      cursor: pointer;
      font-size: 16px;
      color: #108ee9;
    }
    .video-wrap{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .video-white{
        display: inline-block;
        width: 260px;
        height: 310px;
        margin: 20px 10px;
      }
      .video{
        display: inline-block;
        width: 260px;
        height: 310px;
        margin: 20px 10px;
        border-radius: 5px;
        border: 1px solid #ccc;
        cursor: pointer;
        vertical-align: middle;
        .img{
          width: 258px;
          height: 135px;
          border:none;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
        .video-title{
          font-size: 16px;
          color: #000;
          font-weight: bold;
          text-align: left;
          padding: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .video-text{
          font-size: 14px;
          color: #000;
          text-align: left;
          padding: 3px 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .video-content{
          display: inline-block;
          width: 100%;
          font-size: 14px;
          color: gary;
          text-align: left;
          padding: 3px 10px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
        }
      }
    }
  }
  .footer{
    height: 70px;
    width: 100%;
    background: #272727;
    color: #fff;
    text-align: center;
    line-height: 70px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/video.vue